import { reduce } from "et3-type-guards";
import React from "react";
import Stack from "@mui/material/Stack";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserMessagesStore from "../../../stores/user-store/messages-store";
import KhattabatUserMessagesForm from "./user-messages-form/KhattabatUserMessagesForm";
import UserMessagesData from "./user-messages-data";

const UserMessages = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_MESSAGES", "USER_MESSAGES");
    getUserMessagesStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("MONITOR_USER_MESSAGES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Stack
        spacing={3}
        sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}
      >
        <KhattabatUserMessagesForm />
        <UserMessagesData />
      </Stack>
    </ET3PageDiv>
  );
});
export default UserMessages;
